import React from 'react'
import "./Testimonials.css"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import button from "../Images/button.png";
import symbol from "../Images/symbol.png";
import t1 from "../Images/t1.png";
import t2 from "../Images/t2.png";
import t3 from "../Images/t3.png";

const data = [
    {
        id: 1,
        image: t1,
        name: "Riya Chaudhary",
        position: "— Retail Startup, India",
        feedback:
            "It was almost like having a full-fledged IT team with whom we could share our vision and watch it being implemented to perfection.",
    },
    {
        id: 2,
        image: t2,
        name: "Priya Desuza",
        position: "— Fashion Brand, Mumbai",
        feedback:
            "Absolutely. They delivered a sleek, mobile-first website that started ranking on Google within weeks.",
    },
    {
        id: 3,
        image: t3,
        name: "Karan Jain",
        position: "— SaaS Platform, Bangalore",
        feedback:
            "Their in-house team didn’t just build our platform — they became our tech partners. Always proactive, always transparent.",
    },
    {
        id: 4,
        image: t2,
        name: "Priya Desuza",
        position: "— Fashion Brand, Mumbai",
        feedback:
            "Absolutely. They delivered a sleek, mobile-first website that started ranking on Google within weeks.",
    },
];
const settings = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src={button} alt="Next" className="nextArrow" />,
    prevArrow: <img src={button} alt="Previous" className="prevArrow" />,
    responsive: [
        {
            breakpoint: 1150,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
            },
        },
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 1,
            },
        },
    ],
};
const Testimonials = () => {
    return (
        <div id='testimonials'>
            <div className="section">
                <div className="container">
                    <h2 className="heading">
                        Client Testimonials
                    </h2>
                    <Slider {...settings}>
                        {data.map((item) => {
                            return (
                                <div className="fwrapper" key={item.id}>
                                    <div className="fbox">
                                        <div className="symbolbox">
                                            <img src={symbol} alt="" className="symbolimage" />
                                        </div>
                                        <div className="fcontent">
                                            <p>{item.feedback}</p>
                                            <div className="personinfo">
                                                <h3>{item.name}</h3>
                                                <h4>{item.position}</h4>
                                            </div>
                                        </div>
                                        <div className="profilebox">
                                            <img src={item.image} alt="" className="profileimage" />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default Testimonials